import React from 'react'
import Layout from '../../components/Layout'

const AppAssetsPage = () => {
    return (
        <React.Fragment>
            AppAssetsPage
        </React.Fragment>
    )
}

export default AppAssetsPage
